import React, { Component } from "react";
import { Link } from "react-router-dom";
import history from "helpers/History";

export default class Button extends Component {
  constructor(props) {
    super(props);
    this.delayedClick = this.delayedClick.bind(this);
  }

  //Scrolls to the top of the page, then changes to desired route
  delayedClick(event) {
    event.preventDefault();
    let to = this.props.to;
    let hasRedirected = false;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
    window.addEventListener("scroll", function(e) {
      if (window.scrollY === 0 && hasRedirected === false) {
        setTimeout(() => {
          history.push(to);
          hasRedirected = true;
        }, 0);
      }
    });
  }

  render() {
    let button;

    this.props.delay
      ? (button = (
          <Link
            className={this.props.className}
            to={this.props.to}
            onClick={this.delayedClick}
          >
            {this.props.children}
          </Link>
        ))
      : (button = (
          <Link className={this.props.className} to={this.props.to}>
            {this.props.children}
          </Link>
        ));

    return button;
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx